import { render, staticRenderFns } from "./towerBigScreen.vue?vue&type=template&id=7947f51e&scoped=true&"
import script from "./towerBigScreen.vue?vue&type=script&lang=js&"
export * from "./towerBigScreen.vue?vue&type=script&lang=js&"
import style0 from "./towerBigScreen.vue?vue&type=style&index=0&id=7947f51e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7947f51e",
  null
  
)

export default component.exports